var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
/**
 * Copied over from @theme-ui/components and adapted.
 *  @see https://github.com/system-ui/theme-ui/blob/master/packages/components/src/Grid.js
 */
import Box from "./Box";
const px = (n) => (typeof n === "number" ? n + "px" : n);
const widthToColumns = (width, repeat) => Array.isArray(width)
    ? width.map((w) => widthToColumns(w, repeat))
    : !!width && `repeat(auto-${repeat}, minmax(${px(width)}, 1fr))`;
const countToColumns = (n) => Array.isArray(n)
    ? n.map(countToColumns)
    : !!n && (typeof n === "number" ? `repeat(${n}, 1fr)` : n);
/**
 * Creates a css grid.
 * @param {object} props
 * @param {number | string | Array<number | string>} [props.width] The width of the columns.
 * @param {number | string} [props.height] The height of the columns.
 * @param {number | number[]} [props.columns] The number of equal-sized columns.
 * @param {number | string} [props.gap] The gap between the columns, measured in the spacing scale.
 * @param {'fit' | 'fill'} [props.repeat] 'fit' uses the auto-fit algorithm that maximizes the content, whereas 'fill' maximizes the number of columns. See also https://css-tricks.com/auto-sizing-columns-css-grid-auto-fill-vs-auto-fit/
 * @param {React.ReactNode} [props.children] The grid elements.
 * @returns
 */
export default function Grid(_a) {
    var { width, height, columns, gap = 3, repeat = "fit" } = _a, props = __rest(_a, ["width", "height", "columns", "gap", "repeat"]);
    const gridTemplateColumns = !!width
        ? widthToColumns(width, repeat)
        : countToColumns(columns);
    return (_jsx(Box, Object.assign({ sx: Object.assign({ display: "grid", gap,
            gridTemplateColumns }, (typeof height === "number" && {
            gridAutoRows: `minmax(${height}px, auto)`,
        })) }, props)));
}
//# sourceMappingURL=Grid.js.map